import * as React from 'react';
import {
  idadeRelativa,
  parseDataBr,
  rotuloMarca,
  statusAtualizacao,
} from './statusAtualizacao';

/**
 * Uma linha da matriz "marca x etapa do ETL".
 *
 * A primeira coluna (MARCA) é fixa na horizontal; as demais mostram o horário
 * da última atualização colorido pelo status (hoje / ontem / atrasado / sem
 * dado) e, abaixo, o tempo decorrido.
 */
export default function RowAtualizacoes({ row }) {
  const colunas = Object.entries(row);

  return (
    <tr>
      {colunas.map(([chave, valor]) => {
        if (chave === 'MARCA') {
          return (
            <td key={chave} className="col-marca">
              {rotuloMarca(valor)}
            </td>
          );
        }

        const status = statusAtualizacao(valor);
        const data = parseDataBr(valor);

        // Sem data válida: mostra "-" (ou a mensagem de erro que veio da API,
        // que também é útil para o time de operação identificar o problema).
        const texto = data
          ? data.toLocaleString('pt-BR')
          : typeof valor === 'string' && valor.trim()
            ? valor
            : '-';

        return (
          <td key={chave} className={`status-${status}`}>
            <span className="atualizacoes-celula">
              <span className="atualizacoes-hora">{texto}</span>
              {data && (
                <span className="atualizacoes-idade">{idadeRelativa(valor)}</span>
              )}
            </span>
          </td>
        );
      })}
    </tr>
  );
}
